export default __webpack_public_path__ + "static/media/relative.e5170e2c.png";